import './App.css'
import AuthorizedLayout from './components/layout/AuthorizedLayout'
import {Navigate, Route, Routes, useNavigate} from 'react-router-dom'
import { useCallback } from 'react'
import { Security, LoginCallback } from '@okta/okta-react'
import { toRelativeUrl } from '@okta/okta-auth-js'
import { oktaAuth } from './security/OktaConfig'
import LoginError from './pages/LoginError'
import { ProductWeightsOverview } from './pages/ProductWeightsOverview'


function AppInSecureContext() {
    return (
        <div>
            <Routes>
                <Route path="/" element={<AuthorizedLayout requiredGroup={window.env.REACT_APP_GROUP_NAME_PRODUCT_WEIGHTS} />}> 
                    <Route index element={<Navigate to="product-weights" replace />} />
                    <Route path="product-weights/*" element={<ProductWeightsOverview/>} />
                </Route>
                <Route path="/implicit/callback" element={<LoginCallback errorComponent={(props) => <LoginError {...props} requiredGroup={window.env.REACT_APP_GROUP_NAME_APP} />} />} />
                <Route path="*" element={<Navigate to='/product-weights' replace />} />
            </Routes>
        </div>
    )
}

const App = () => {
    const navigate = useNavigate()
    const restoreOriginalUri = useCallback(
        (_oktaAuth: any, originalUri: string) => {
            navigate(toRelativeUrl(originalUri || '/', window.location.origin), { replace: true })
        },
        [navigate]
    )

    return (
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
              <AppInSecureContext />
        </Security>
    );
}


export default App
